module.exports = __webpack_public_path__ + "img/hl5.5d07586a.png";